import * as actions from './actions';

const initialState = {
    error: null,
    mushrooms: [],
    loading: false,
    initialMushrooms: false
};




export default function mushroomsReducer(state = initialState, action) {
    switch (action.type) {
        // fetch
        case actions.FETCH_MUSHROOM_BY_COUNTRY.REQUEST:
            return { ...state, error: null, loading: true };

        case actions.FETCH_MUSHROOM_BY_COUNTRY.SUCCESS: {
            return { ...state, initialMushrooms: true, mushrooms: action.payload, loading: false };
        }
        case actions.FETCH_MUSHROOM_BY_COUNTRY.FAILURE:
            return { ...state, initialMushrooms: false, error: action.payload, loading: false };

        default:
            return state;
    }
}